// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"bb36206c","990":"e3c309b2"}[chunkId] + ".chunk.css";
};